<template>
    <div>
      <CRow class="mb-3 search-panel">
        <CCol sm="2" xs="12">
            <div class="form-group">
                <label>Chọn sản phẩm
                    <span class="required">* </span>
                </label>
                <input type="text" :placeholder="itemChooseProduct.productName"
                    class="form-control" readonly v-model="itemChooseProduct.productName"
                    @click="chooseProduct()"/>
                <div class="valid-error" v-show="!(productInput.data.validator ? productInput.data.validator.isValid : true)">
                    {{ productInput.data.validator ? productInput.data.validator.errorMessage : "" }}
                </div>
            </div>
        </CCol>
        <CCol sm="2" xs="12">
            <BaseSelect :options="warehouseSelect.options" :data="warehouseSelect.data"
                ref="warehouseSelect"></BaseSelect>
        </CCol>
        <CCol>
          <div class="form-group">
            <label style="color: white"></label>
            <div style="margin-top: 10px">
              <CButton style="float: right;margin-left: 5px;" color="primary" v-c-tooltip.hover="'Kiểm tra'"
                class="btn-action-primary" @click="loadDataMainTable(true)">
                <i class="fa fa-refresh"></i>&nbsp;&nbsp;Kiểm tra
              </CButton>
            </div>
          </div>
        </CCol>
      </CRow>


      <CCard v-if="statistic && statistic != undefined">
        <CCardHeader color="light">
            <strong> Số lượng </strong>
        </CCardHeader>
        <CCardBody class="row text-center">
            <div class="col" style="color: #f9b115!important">
                <div class="text-value-lg">
                {{ statistic.remainingQuantity || 0 }}
                </div>
                <div class="text-uppercase text-muted small">
                Số lượng tồn kho
                </div>
            </div>
            <div class="c-vr"></div>
            <div class="col" style="color: red!important">
                <div class="text-value-lg">
                {{ statistic.inQuantity - statistic.remainingQuantity || 0 }}
                </div>
                <div class="text-uppercase text-muted small">
                Số lượng xuất kho
                </div>
            </div>
            <div class="c-vr"></div>
            <div class="col" style="color: #1bbf1b!important">
                <div class="text-value-lg">
                {{ statistic.inQuantity || 0 }}
                </div>
                <div class="text-uppercase text-muted small">
                Số lượng nhập kho
                </div>
            </div>
        </CCardBody>
    </CCard>

      <CCard class="content-fade-in mt-3p5">
        <CCardBody>
          <BaseTable :options="mainTable.options" :slots="mainTable.slots" :dataSource="mainTable.dataSource" ref="mainTable">
            <template #index="{index}">
                <td>{{ $refs.mainTable.getTotalElementByPage + index }}</td>
            </template>

            <template #warehouse="{ item }">
              <td>
                {{ item.warehouseCode }} - {{ item.warehouseName }}
              </td>
            </template>

            <template #createDate="{ item }">
              <td>
                {{ $helper.formatDateDDMMYYYYHHMM(item.createDate) }}
              </td>
            </template>

            <template #quantity="{ item }">
              <td>
                <span v-if="item.inventoryType == 'in'" style="color: #2eb85c;">
                    {{ item.quantity * 1 }}
                </span>
                <span v-else style="color:red">
                    {{ item.quantity * -1 }}
                </span>
              </td>
            </template>

            <template #inventoryDate="{ item }">
              <td>
                {{ $helper.formatDateDDMMYYYY(item.inventoryDate) }}
              </td>
            </template>
            <template #accountingDate="{ item }">
              <td>
                {{ $helper.formatDateDDMMYYYYHHMM(item.accountingDate) }}
              </td>
            </template>
            <template #inventoryType="{ item }">
              <td>
                <span v-if="item.inventoryType == 'in'">
                    Nhập kho
                </span>
                <span v-if="item.inventoryType == 'out'">
                  Xuất kho
                </span>
                <div v-if="$helper.stockPurposeLabel(item.inventoryType, item.purpose)">
                  {{ $helper.stockPurposeLabel(item.inventoryType, item.purpose) }}
                </div>
              </td>
            </template>
            <template #state="{ item }">
              <td>
                <!-- {{ item.state }} -->
                <CBadge v-if="item.state == 'draft'" color="secondary" class="mr-1">Nháp</CBadge>
                <CBadge v-if="item.state == 'done'" color="success" class="mr-1">Hoàn thành</CBadge>
              </td>
            </template>
          </BaseTable>
        </CCardBody>
      </CCard>

      <BaseLoading :loading="loading.value"></BaseLoading>
      <BaseChooseProduct v-if="isShowChooseProduct" @item:selected="chooseProductSelected($event)"
            @close-modal="closeModelProduct($event)"></BaseChooseProduct>
    </div>
  </template>
  
  <script>
  import BaseTable from "../base/BaseDataTable";
  import BaseInput from "../base/BaseInput";
  import BaseLoading from "../base/BaseFormLoading";
  import BaseSwitch from "@/views/base/BaseSwitch";
  import BaseSelect from "@/views/base/BaseSelect2";
  import BaseChooseProduct from "@/views/base/BaseChooseProduct";
  
  export default {
    name: "CheckInOut",
    components: {
      BaseSwitch,
      BaseTable,
      BaseInput,
      BaseSelect,
      BaseChooseProduct,
      BaseLoading
    },
    notifications: {
      showSuccessMsg: {
        type: "success",
        title: "Success"
      },
      showErrorMsg: {
        type: "error",
        title: "Error"
      },
      showWarningMsg: {
        type: "warn",
        title: "warn"
      }
    },
    data() {
      let that = this;
  
      return {
        loading: { value: false },
        statistic: {},
        isShowChooseProduct: false,
        itemChooseProduct: {},
        productInput: {
          options: {
            placeholder: "Sản phẩm",
            label: 'Sản phẩm',
          },
          data: {
            name: "productId",
            model: "",
            updateTrigger: function () {
              return that.$refs.mainTable;
            },
            validator: {
                isValid: true,
                errorMessage: "",
                valid: function () {

                    let value = that.productInput.data.model;

                    if(!value || value == "") {
                        this.isValid = false;
                        this.errorMessage = "Sản phẩm không được để trống";
                    } else {
                        this.isValid = true;
                        this.errorMessage = "";
                    }

                    return this.isValid;
                }
            }
          }
        },
        warehouseSelect: {
            options: {
                filter: true,
                label: "Kho",
                selectAllText: "Chọn kho",
                'keyField': 'value',
                'valueField': 'text',
            },
            data: {
                name: "warehouseId",
                items: [],
                model: "",
                source: {
                    url: '/warehouse/list-warehouse',
                    dataSubmit: function () {
                        return {}
                    },
                    response: function (dataResponse) {
                        that.warehouseSelect.data.items = dataResponse.data;
                    }
                },
                
                // updateTrigger: function () {
                //     return that.loadDataMainTable();
                // },
                validator: {
                    isValid: true,
                    errorMessage: "",
                    valid: function () {
                        return this.isValid;
                    }
                },
            }
        },
        labelIcon: {
          labelOn: '\u2713',
          labelOff: '\u2715'
        },
        mainTable: {
          options: {
            fields: [
              {key: "index", label: "STT"},
              { key: "createDate", label: "Ngày tạo"},
              { key: "warehouse", label: "Kho" },
              { key: "documentNo", label: "Mã phiếu" },
              { key: "inventoryType", label: "Loại phiếu" },
              { key: "quantity", label: "Số lượng" },
              { key: "inventoryDate", label: "Ngày chứng từ"},
              { key: "state", label: "Trạng thái"},
              { key: "accountingDate", label: "Ngày hoàn thành" },
              { key: "description", label: "Ghi chú" },
            ],
            slots: ["index", "createDate", "inventoryDate", "inventoryType", "accountingDate", "warehouse", "state", "quantity"],
            sorter: true,
            columnFilter: false,
            clickableRows: true,
            hover: false,
            itemsPerPageSelect: { label: ' ', values: [15, 20, 30, 50, 100], external: true },
            lazyLoad: false,
            pageSize: 20,
          },
          dataSource: {
            url: "/stock/check-in-out",
            dataSubmit: function () {
              return that.$helper.setupDataSubmit(that.$data);
            },
            response: function (dataResponse) {
              return dataResponse.data;
            }
          }
        }
      };
    },
    methods: {
        chooseProduct() {
            this.itemChooseProduct = {};
            this.isShowChooseProduct = true;
        },
        chooseProductSelected(event) {
            this.productInput.data.model = event.id;
            this.itemChooseProduct.productId = event.id;
            this.itemChooseProduct.productName = event.name;
            this.loadDataMainTable();
            this.isShowChooseProduct = false;
        },
        closeModelProduct() {
            this.isShowChooseProduct = false
        },
      loadDataMainTable: function (isUpdateFilter) {
        let that = this;
        let isValid = true;
        isValid &= this.productInput.data.validator.valid();

        if (!isValid) {
            return;
        }

        this.checkQuantity();
        this.$refs.mainTable.loadData(true, isUpdateFilter);
      },
      checkQuantity: function () {
        let that = this;
        this.$helper.loadDataSource({
            loading: that.loading,
            url: "/stock-line/check-quantity-in-out-stock",
            isJsonContentType: false,
            dataSubmit: function () {
                return { 
                    productId: that.productInput.data.model,
                    warehouseId: that.warehouseSelect.data.model
                }
            },
            successCallback: function (response) {
                that.statistic = response.data.data;
                that.loading.value = false;
            },
            errorCallback: function (error) {
                that.$helper.handleError(that.$router, error);
                that.loading.value = false;
            }
        });
      }
    },
    created: function () {
    },
    mounted() {
    },
    watch: {
        "warehouseSelect.data.model": function() {
            this.loadDataMainTable()
        }
    },
    computed: {}
  };
  </script>
  <style scoped>
  .td-roles {
    max-width: 250px;
  }
  
  </style>
  